import { SearchUser } from "../../../store/slices/GlobalSearchSlice";
import { USER_STATUS } from "../../common/userStatus";

export const ROLE_DISPLAY: Record<string, string> = {
    SUPER_ADMIN: "Super Admin",
    ORG_ADMIN: "Organization Admin",
    FINLEY_USER: "Finley User",
    FINANCIAL_COACH: "Coach",
    FINLEY_ADMIN: "Finley Admin",
    FINLEY_ORG_ADMIN: "Finley Organization Admin",
};

export const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export const STATUS_CONFIG: Record<string, { displayName: string; color: string }> = {
    [USER_STATUS.ACTIVE]: { displayName: "Active", color: "bg-green-500" },
    [USER_STATUS.INVITED]: { displayName: "Invited", color: "bg-gray-400" },
    [USER_STATUS.DEACTIVATED]: { displayName: "Deactivated", color: "bg-red-400" },
    [USER_STATUS.SIGNED_UP]: { displayName: "Signed Up", color: "bg-yellow-500" },
};

export const getUserStatus = (user: SearchUser) => {
    const status = user.userStatus || USER_STATUS.ACTIVE;
    const config = STATUS_CONFIG[status] || STATUS_CONFIG[USER_STATUS.ACTIVE];
    const dateLabel = user.userStatusDate ? formatDate(user.userStatusDate) : "";

    if (status === USER_STATUS.ACTIVE) {
        return { label: dateLabel ? `Active since ${dateLabel}` : "Active", color: config.color };
    }
    return { label: dateLabel ? `${config.displayName} on ${dateLabel}` : config.displayName, color: config.color };
};
